import { render, staticRenderFns } from "./loyaltyMomentPreviewPlaceholder.vue?vue&type=template&id=82ede69e&"
import script from "./loyaltyMomentPreviewPlaceholder.vue?vue&type=script&lang=js&"
export * from "./loyaltyMomentPreviewPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports